module.exports = __webpack_public_path__ + "img/facebook.18c8fcd4.svg";